import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendOrderItem,
	FrontendProduct,
	FrontendSampleSpecification,
	FrontendSampleTestBatch,
} from "node-library/dist/portal";

import DeleteSampleConfirmModal from "../../../common-components/modals/deleteSampleConfirmModal";
import HandlingShippingCard from "./handlingShippingCard";
import ItemCard from "./itemCard";

interface Props {
	itemList: Array<FrontendOrderItem>;
	currency: string;
	deleteItem: (ItemId: string) => void;
	goToUpdateItem: (itemToUpdate: FrontendOrderItem) => void;
	isReadOnlyTable?: boolean;
	isInNestedCard?: boolean;
	handlingFee: number;
	shippingFee: number;
	handlingDescription: string;
	shippingDescription: string;
	fullServiceShippingSolution: boolean;
	deleteHandlingFee: () => void;
	deleteShippingFee: () => void;
	goToUpdateHandlingShippingFee: () => void;
}

export default function ItemPreviewTable(props: Props) {
	const { t: translation } = useTranslation();

	const {
		itemList,
		currency,
		deleteItem,
		goToUpdateItem,
		isReadOnlyTable,
		isInNestedCard,
		handlingFee,
		shippingFee,
		shippingDescription,
		handlingDescription,
		fullServiceShippingSolution,
		deleteHandlingFee,
		deleteShippingFee,
		goToUpdateHandlingShippingFee,
	} = props;

	//confirm modals
	const [deleteProductConfirmOpen, setDeleteProductConfirmOpen] =
		useState<boolean>(false);
	const [proceedAction, setProceedAction] = useState<() => void>(
		() => () => {}
	);

	const itemRows: Array<React.ReactNode> = itemList
		? itemList.map((item: FrontendOrderItem, index: number) => {
				return (
					<ItemCard
						key={index}
						item={item}
						currency={currency}
						index={index}
						deleteItem={() => {
							setProceedAction(() => () => deleteItem(item.orderItemId));
							setDeleteProductConfirmOpen(true);
						}}
						goToUpdateItem={() => goToUpdateItem(item)}
						isReadOnlyTable={isReadOnlyTable}
						isNestedCard={isInNestedCard}
					/>
				);
		  })
		: [];

	return (
		<>
			<div
				className={`item-preview-table-container ${
					isInNestedCard ? `item-preview-table-nested` : ``
				}`}
			>
				{itemRows}
				{handlingFee > 0 && (
					<HandlingShippingCard
						handlingFee={handlingFee}
						description={handlingDescription}
						deleteFee={deleteHandlingFee}
						goToUpdateHandlingShippingFee={goToUpdateHandlingShippingFee}
						isReadOnlyTable={isReadOnlyTable}
						isNestedCard={isInNestedCard}
						currency={currency}
					/>
				)}
				{(shippingFee > 0 || Boolean(fullServiceShippingSolution)) && (
					<HandlingShippingCard
						shippingFee={shippingFee}
						description={shippingDescription}
						fullServiceShippingSolution={fullServiceShippingSolution}
						deleteFee={deleteShippingFee}
						goToUpdateHandlingShippingFee={goToUpdateHandlingShippingFee}
						isReadOnlyTable={isReadOnlyTable}
						isNestedCard={isInNestedCard}
						currency={currency}
					/>
				)}
			</div>
			<DeleteSampleConfirmModal
				open={deleteProductConfirmOpen}
				setOpen={setDeleteProductConfirmOpen}
				proceedAction={proceedAction}
			></DeleteSampleConfirmModal>
		</>
	);
}
